module.exports = function () {
    // const Hamburger = $('.hamburger');
    // const Menu = $('.sidebar-overlay');
    // const Body = $('body');
    // const Overlay = $('.bg-clicker');

    // let canWeToggle = true;

    // $(Hamburger).on('click', function () {
    //     if (canWeToggle) {
    //         // Overlay.fadeIn(1000);
    //         $(this).toggleClass('open')
    //         $(Menu).toggleClass('open')
    //         // animateOverlay()
    //         Body.toggleClass('before-hidden');
    //         $(Body).toggleClass('stop-scrolling')
    //     }
    // })

    // Overlay.on('click', (e) => {
    //     if (canWeToggle) {
    //         Menu.removeClass('open');
    //         Body.removeClass('stop-scrolling');
    //         // console.log('overlay Lick');
    //         // $(this).fadeOut(1000);
    //     }

    //     canWeToggle = false;
    //     Body.addClass('before-hidden');

    //     setTimeout(() => {
    //         canWeToggle = true;
    //     }, 1500);
    // });

    // $('.sidebar-overlay').on('click', (e) => {
    //     e.stopPropagation();
    //     // console.log('sidebarClick');
    // });

    // // $(document).on('click', (e) => {
    // //     if (canWeToggle) {
    // //         Menu.removeClass('open')
    // //         animateOverlay()
    // //         Body.removeClass('stop-scrolling')
    // //         // animateOverlay()
    // //     }
    // // })

    // const animateOverlay = () => {
    //     canWeToggle = false;
    //     setTimeout(() => {
    //         canWeToggle = true;
    //     }, 2000);

    //     if (Body.hasClass('before-hidden')) {
    //         Body.removeClass('before-hidden');
    //     } else {
    //         setTimeout(() => {
    //             Body.addClass('before-hidden');
    //         }, 1500);
    //     }

    // }
};